import { EMPTY, WALL, indexOf } from './board.js';
import { pieceCells } from './piece.js';
/**
 * Текстовая запись поля для тестов и отладки. Строка — ряд поля сверху вниз,
 * клетки — токены из двух символов через пробел:
 *   ..   пусто
 *   V0   вирус цвета 0
 *   B0   вирус цвета 0 в «Биоплёнке»
 *   ##   стенка сосуда
 *   XX   тело босса
 *   T0   часть босса-гибрида (щупальце) с номером 0 … 9
 *   G0   сторожевой вирус босса в «Биоплёнке»; Q0 — сторожевой вирус без плёнки
 *   S0   одиночный сегмент
 *   L0 R0  горизонтальная капсула: левая и правая половины
 *   U0 D0  вертикальная капсула: верхняя и нижняя половины
 * В formatBoard активная капсула записывается строчными буквами (l0 r0 / u0 d0).
 */
const LINK_BY_LETTER = {
    S: 'none',
    L: 'right',
    R: 'left',
    U: 'down',
    D: 'up',
};
const LETTER_BY_LINK = {
    none: 'S',
    right: 'L',
    left: 'R',
    down: 'U',
    up: 'D',
};
function parseToken(token, x, y) {
    if (token === '..') {
        return EMPTY;
    }
    if (token === '##') {
        return WALL;
    }
    if (token === 'XX') {
        return { kind: 'boss' };
    }
    const letter = token[0] ?? '';
    const color = Number(token.slice(1));
    if (token.length !== 2 || !Number.isInteger(color)) {
        throw new SyntaxError(`bad token "${token}" at (${x}, ${y})`);
    }
    if (letter === 'V') {
        return { kind: 'virus', color };
    }
    if (letter === 'B') {
        return { kind: 'virus', color, shield: true };
    }
    if (letter === 'G') {
        return { kind: 'virus', color, shield: true, guard: true };
    }
    if (letter === 'Q') {
        return { kind: 'virus', color, guard: true };
    }
    if (letter === 'T') {
        return { kind: 'boss', part: color };
    }
    const link = LINK_BY_LETTER[letter];
    if (link === undefined) {
        throw new SyntaxError(`bad token "${token}" at (${x}, ${y})`);
    }
    return { kind: 'segment', color, link };
}
export function parseBoard(rows) {
    const grid = rows.map((row) => row.trim().split(/\s+/));
    const height = grid.length;
    const width = grid[0]?.length ?? 0;
    if (height === 0 || width === 0 || grid.some((r) => r.length !== width)) {
        throw new SyntaxError('board rows must be non-empty and of equal width');
    }
    const cells = grid.flatMap((row, y) => row.map((token, x) => parseToken(token, x, y)));
    return { width, height, cells };
}
function formatCell(cell) {
    switch (cell.kind) {
        case 'empty':
            return '..';
        case 'wall':
            return '##';
        case 'virus':
            if (cell.guard)
                return `${cell.shield ? 'G' : 'Q'}${cell.color}`;
            return `${cell.shield ? 'B' : 'V'}${cell.color}`;
        case 'boss':
            return cell.part === undefined ? 'XX' : `T${cell.part}`;
        case 'segment':
            return `${LETTER_BY_LINK[cell.link]}${cell.color}`;
    }
}
export function formatBoard(board, active = null) {
    const tokens = board.cells.map(formatCell);
    if (active) {
        for (const c of pieceCells(active)) {
            tokens[indexOf(board, c.x, c.y)] = `${LETTER_BY_LINK[c.link].toLowerCase()}${c.color}`;
        }
    }
    const rows = [];
    for (let y = 0; y < board.height; y++) {
        rows.push(tokens.slice(y * board.width, (y + 1) * board.width).join(' '));
    }
    return rows;
}
//# sourceMappingURL=board-text.js.map